import React from 'react';
import './Chapters.scss';
import graphic1 from '../../assets/graphic1.jpg';

function Chapter1() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        The bushfires that swept across 55,000 square miles of Australia in 2019 and 2020 killed or
        displaced an estimated 3 billion animals, according to sources including the U.S. National
        Institutes of Health—a hard hit to a country that has already lost 39 mammal species. In
        response to warnings that future fires and climate change could bring more of the same,
        Australia adopted new conservation goals in October 2022 to prevent further extinctions
        within its borders.
      </p>

      <img src={graphic1} alt="graphic" style={{ margin: '2rem 0' }} />

      <p className="chapter__paragraph">
        While most people fear losing beloved species, such as wombats and koalas, all
        species—postcard-perfect or microscopic—are important. Fertile soil, stable coastlines, and
        our agriculture and medicines depend on hundreds of thousands of interconnected creatures
        feeding, processing nutrients, growing roots, and decomposing all around us.
      </p>
      <p className="chapter__paragraph">
        At the University of Sydney’s Australasian Wildlife Genomics Group, Senior Research Manager
        <a href="https://www.youtube.com/watch?v=nxCZZ6KJuh8" target="blank" rel="sponsored">
          {' '}
          Dr. Carolyn Hogg
        </a>{' '}
        is creating a genomic legacy database and an online tool to assist with conservation efforts
        and breeding programs for Australia’s threatened species. The technology is accessible to
        conservation managers and researchers around the world and allows Dr. Hogg’s team to manage
        a massive amount of data on a small research budget, focus its energy on analytics (not IT),
        and move with the urgency that climate change demands.
      </p>
    </section>
  );
}

export default Chapter1;
